var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTacobell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 70.796,
    viewBox: "0 0 202 70.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 70.796,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.148,39.08A39.074,39.074,0,1,0,0,39.08l0,.039V69.533A1.262,1.262,0,0,0,1.265,70.8H76.883a1.267,1.267,0,0,0,1.265-1.263Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2,21.814c-1.332-3.291-12.728-.821-28.59,7.689C18.112,37.822,8.983,47.44,10.352,50.3c1.451,3.03,17.364.9,30.144-6.179C57.82,34.534,63.857,25.912,62.2,21.814M24.933,45.774a9.71,9.71,0,0,1-7.016-2.808A69.11,69.11,0,0,1,33.454,31.823a9.7,9.7,0,0,1-8.521,13.95",
    transform: "translate(7.931 15.843)",
    fill: "#68298c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.378,65.536a7,7,0,0,0,3.115,1.915c.036.009.423.14.423.14H1.265A1.263,1.263,0,0,1,0,66.328L0,35.914l0-.039A39.033,39.033,0,0,1,16.283,4.13v0l-.448.533c-1.048,1.332-.913,2.6-.275,4.288.41,1.137-.835,2.428-1.5,3.156A21.634,21.634,0,0,0,8.1,26.731c-.295,6.677,1.668,12.6,2.339,15.721a34.792,34.792,0,0,1,.867,5.025c2.524-2.131,5.22-4.21,7.947-6.114,4.378-2.886,7.94-5.03,11.055-6.707,6.993-3.758,8.783-3.355,3.265-.13A93.945,93.945,0,0,0,19.045,44.773C4.758,57.653,6.892,64.019,8.378,65.536",
    transform: "translate(0 3.205)",
    fill: "#68298c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.153,53.63A1.269,1.269,0,0,1,64.889,54.9H15.453s.67-.14.709-.151a77.69,77.69,0,0,0,21.815-8.362c15.288-7.909,25.308-18.109,27.956-25.546l.126-.348s.009.112.023.339c.041.618.071,1.561.071,2.35Z",
    transform: "translate(11.995 15.903)",
    fill: "#68298c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.385,3.92h0A39.1,39.1,0,0,1,67.211,28.961a7.257,7.257,0,0,0-1.977-1.171A20.209,20.209,0,0,0,61,26.622c-2.417-.455-4.883-.583-7.627-2.085-4.982-2.725-11.615-14.386-22.24-17.469A22.869,22.869,0,0,0,20.54,6.481c-.863.151-2.627.336-3.25-.483-1.258-1.655-2.21-2.627-4.163-2.268-.254.048-.741.19-.741.19",
    transform: "translate(9.613 0)",
    fill: "#9e7fba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.734,32.928h7.647V8.054h9.67V1.44H47.107V8.054h9.627Z",
    transform: "translate(36.565 1.117)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.139,32.929l1.753-4.588h12.64l1.71,4.588h8.5L78.878,1.44H72.444l-13.4,31.489ZM75.37,10.888l3.824,11.155h-7.92Z",
    transform: "translate(45.828 1.117)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.878,33.7a16.541,16.541,0,0,0,13.178-5.714l-6.341-4.723A8.282,8.282,0,0,1,92.7,26.6c-5.037,0-7.908-3.87-7.908-9.178,0-5.354,2.961-9.265,8.179-9.265a7.182,7.182,0,0,1,6.3,3.417l6.208-4.455a15.067,15.067,0,0,0-12.5-5.981c-10.608,0-16.229,7.286-16.229,16.283S82.315,33.7,92.878,33.7",
    transform: "translate(59.566 0.882)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.581,33.7c9.94,0,16.059-7.288,16.059-16.283S119.521,1.138,109.581,1.138c-10.032,0-16.1,7.284-16.1,16.283S99.549,33.7,109.581,33.7m0-25.549c5.037,0,8.007,3.913,8.007,9.267,0,5.261-2.97,9.13-8.007,9.13-5.084,0-8.052-3.869-8.052-9.13,0-5.354,2.968-9.267,8.052-9.267",
    transform: "translate(72.557 0.883)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.239,36.57A6.952,6.952,0,0,0,75.6,29.552c0-4.677-3.687-7.421-10.931-7.421H52.525V53.618H66.2c8.005,0,11.874-2.922,11.874-9.041,0-4.227-2.384-7.062-6.835-8.007M59.767,28.25h3.016c3.687,0,5.172.764,5.172,3.012,0,2.382-1.442,3.284-4.318,3.284h-3.87Zm4.545,18.8H59.767V40.527h4.68c4.092,0,5.847.9,5.847,3.284,0,2.519-1.352,3.24-5.982,3.24",
    transform: "translate(40.771 17.178)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.294,40.889H89.61V34.5H76.294V28.745H92.262V22.13H68.647V53.617H92.621V47.006H76.294Z",
    transform: "translate(53.285 17.177)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,22.13h-7.65V53.617H105.8V47.006H91.9Z",
    transform: "translate(65.399 17.177)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.137,22.13H98.49V53.617h21.547V47.006h-13.9Z",
    transform: "translate(76.449 17.177)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3,37.751a1.27,1.27,0,0,0,.192-.034.722.722,0,0,0,.242-.114.544.544,0,0,0,.163-.208.73.73,0,0,0,.057-.3.6.6,0,0,0-.192-.469.942.942,0,0,0-.648-.172h-1.025v2.325h.384V37.758h.41l.634,1.021h.458Zm-.828-.318v-.675h.577a1.631,1.631,0,0,1,.192.012.554.554,0,0,1,.162.048.275.275,0,0,1,.107.1.326.326,0,0,1,.041.176.317.317,0,0,1-.062.215.346.346,0,0,1-.167.1,1.031,1.031,0,0,1-.24.028h-.609Z",
    transform: "translate(87.003 28.296)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.468,40.026A2.031,2.031,0,1,1,115.5,38a2.033,2.033,0,0,1-2.03,2.03m0-3.707A1.677,1.677,0,1,0,115.145,38a1.679,1.679,0,0,0-1.677-1.677",
    transform: "translate(86.5 27.915)",
    fill: "#010101"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacobell);
export default __webpack_public_path__ + "static/media/tacobell.3c9280e0a2ff21f7f3e4e49e00ed86ba.svg";
export { ForwardRef as ReactComponent };